export enum ContainerType {
  none,
  item,
  group,
}
